export var convertToCustomContentNotification = function (dto) { return ({
    id: dto.id,
    uuid: dto.uuid,
    marketplaceID: dto.marketplace_id,
    key: dto.key,
    name: dto.name,
    content: dto.content
}); };
export var convertToCustomContentNotificationDto = function (customContentNotification) { return ({
    id: customContentNotification.id,
    uuid: customContentNotification.uuid,
    marketplace_id: customContentNotification.marketplaceID,
    key: customContentNotification.key,
    name: customContentNotification.name,
    content: customContentNotification.content
}); };
